import React, { useEffect } from 'react';
import SISolutionPage from '../../images/SISolutionPage.png';

export default function Solution(){
    return (<>
   <img src={SISolutionPage} style={{width:'100%'}}></img>
    </>)
}